import React from "react";
import {Label} from "reactstrap";
import ReactSwitch from "react-switch";
import {ErrorMessage, useField} from "formik";
import {capitalizeFirst} from "../../common/general";

const SwitchField = (props) => {
  const [field, meta, helpers] = useField(props.id);

  const switchHandler = () => {
    helpers.setValue(!field.value)
  }

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        No
      </div>
    )
  }

  const OnSymbol = props => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Yes
      </div>
    )
  }

  return (
    <React.Fragment>
      <Label htmlFor={props.id}>
        {capitalizeFirst(props.name)}
      </Label>
      <ReactSwitch
        uncheckedIcon={<Offsymbol/>}
        checkedIcon={<OnSymbol/>}
        onColor={props.color}
        onChange={switchHandler}
        checked={field.value}
        className="float-end"
      />
      <ErrorMessage name={props.id} component="div" className="invalid-feedback"/>
    </React.Fragment>
  )
}

export default SwitchField